import { addMessages } from '@hana/i18n';

// Khoá chuỗi của màn Giá và Lịch (P2PScreen.tsx). Mã cảng / hãng / tàu, nhãn loại hàng (domain), nhãn thời hạn (format.ts) và "Hôm qua" của mục gần đây không dịch.
addMessages('vi', {
  'p2.cargo': 'Hàng',
  'p2.cargoType': 'Loại hàng',
  'p2.portPh': 'Mã hoặc tên cảng',
  'p2.suggest': 'Gợi ý {v}',
  'p2.rateOf': 'Giá {v}',
  'p2.cheapestTip': 'Giá thấp nhất còn hiệu lực',
  'p2.cheapest': 'Rẻ nhất',
  'p2.svcUnknown': 'Chưa rõ service',
  'p2.axis': '{a} đến {b}, {n} ngày',
  'p2.ts': 'chuyển tải {v}',
  'p2.directLow': 'đi thẳng',
  'p2.directUp': 'Đi thẳng',
  'p2.days': '{n} ngày',
  'p2.buy': 'mua {v}',
  'p2.belowTip': 'Giá chào thấp hơn giá mua · gửi duyệt [SAL-MGR] trước khi báo khách',
  'p2.below': 'Dưới giá mua · cần duyệt',
  'p2.validUntil': 'Hiệu lực đến',
  'p2.detail': 'Mở chi tiết {v}: local charge, lịch tàu, free time, lịch sử',
  'p2.free': 'Free time tại POD',
  'p2.next': 'Chuyến kế',
  'p2.cy': 'Cắt máng CY',
  'p2.carrierSched': 'Lịch tàu của hãng',
  'p2.hCarrier': 'Hãng',
  'p2.hVessel': 'Tàu · Chuyến',
  'p2.hCut': 'Cắt CY',
  'p2.sailing': 'Chuyến {v}',
  'p2.via': 'qua {v}',
  'p2.unmapped': 'Service chưa map',
  'p2.cutCy': 'Cắt máng cảng',
  'p2.book': 'Book chuyến {v}',
  'p2.sPrice': 'Giá thấp → cao',
  'p2.sTt': 'Transit nhanh',
  'p2.sValid': 'Hiệu lực dài',
  'p2.cond': 'Điều kiện tra',
  'p2.from': 'Từ',
  'p2.to': 'đến',
  'p2.pod': 'Cảng đến',
  'p2.pol': 'Cảng đi',
  'p2.dc': 'DC · Hàng khô',
  'p2.rf': 'RF · Hàng lạnh',
  'p2.search': 'Tra giá',
  'p2.lead': 'Tra giá cước theo tuyến',
  'p2.polL': 'Cảng đi (POL)',
  'p2.podL': 'Cảng đến (POD)',
  'p2.swap': 'Đổi chiều POL và POD',
  'p2.etdIn': 'ETD trong',
  'p2.etdRange': 'Khoảng ETD',
  'p2.w2': '2 tuần',
  'p2.w4': '4 tuần',
  'p2.w6': '6 tuần',
  'p2.searchSched': 'Tra lịch',
  'p2.emptyT': 'Chưa có giá hoặc chuyến cho tuyến này',
  'p2.nopermT': 'Chỉ xem lịch tàu',
  'p2.emptyD': 'Gửi Pricing hỏi giá — thường có trả lời trong ngày làm việc.',
  'p2.nopermD': 'Tài khoản này không được tra giá cước. Xin quyền Sales / Pricing ở Cài đặt.',
  'p2.errD': 'Nguồn lịch hãng không phản hồi. Giá đã lưu vẫn tra được khi thử lại.',
  'p2.retry': 'Thử lại',
  'p2.byCarrier': 'Lọc theo hãng',
  'p2.allCarriers': 'Mọi hãng',
  'p2.tier': 'Bậc giá',
  'p2.t1': 'Bậc 1',
  'p2.t2': 'Bậc 2',
  'p2.cost': 'Giá mua',
  'p2.free2': 'Tự đặt margin',
  'p2.editMarg': 'Sửa margin tự đặt',
  'p2.marg': 'Margin',
  'p2.filterRes': 'Lọc kết quả giá',
  'p2.filter': 'Lọc',
  'p2.sort': 'Sắp xếp',
  'p2.reset': 'Đặt lại',
  'p2.validRows': '{n} dòng giá còn hạn',
  'p2.done': 'Xong',
  'p2.results': 'Kết quả giá',
  'p2.expiredNote': 'Giá hết hạn (không vào danh sách)',
  'p2.noSailT': 'Chưa có chuyến trong khoảng ETD này',
  'p2.noSailD': 'Thử nới khoảng ETD hoặc đổi tuyến.',
  'p2.sched': 'Lịch tàu',
  'p2.what': 'Tra gì',
  'p2.title': 'Giá và Lịch',
  'p2.weeks': '{n} tuần',
  'p2.bookN': 'Book {n} chuyến một lần',
  'p2.tickBook': 'Tick chuyến để Multi Book',
  'p2.recentTool': 'Gần đây: tuyến đã tra, hỏi giá đang chờ, báo giá',
  'p2.more': 'Thao tác khác',
  'p2.tickQuote': 'Tick dòng giá để tạo báo giá',
  'p2.quote': 'Tạo báo giá',
  'p2.recentAria': 'Tuyến tra gần đây',
  'p2.recent': 'Tra lại tuyến gần đây',
  'p2.margD': 'Cộng trên giá mua của từng hãng; có thể âm cho giá chào đặc biệt (cần duyệt giá).',
  'p2.cancel': 'Huỷ',
  'p2.apply': 'Áp dụng',
});
addMessages('en', {
  'p2.cargo': 'Cargo',
  'p2.cargoType': 'Cargo type',
  'p2.portPh': 'Port code or name',
  'p2.suggest': 'Suggestions: {v}',
  'p2.rateOf': 'Rate {v}',
  'p2.cheapestTip': 'Lowest valid rate',
  'p2.cheapest': 'Cheapest',
  'p2.svcUnknown': 'Service unknown',
  'p2.axis': '{a} to {b}, {n} days',
  'p2.ts': 'transshipment {v}',
  'p2.directLow': 'direct',
  'p2.directUp': 'Direct',
  'p2.days': '{n} days',
  'p2.buy': 'buy {v}',
  'p2.belowTip': 'Offer below buy rate · send for [SAL-MGR] approval before quoting the customer',
  'p2.below': 'Below buy rate · needs approval',
  'p2.validUntil': 'Valid until',
  'p2.detail': 'Open details of {v}: local charges, sailings, free time, history',
  'p2.free': 'Free time at POD',
  'p2.next': 'Next voyage',
  'p2.cy': 'CY cut-off',
  'p2.carrierSched': 'Carrier sailings',
  'p2.hCarrier': 'Carrier',
  'p2.hVessel': 'Vessel · Voyage',
  'p2.hCut': 'CY cut',
  'p2.sailing': 'Sailing {v}',
  'p2.via': 'via {v}',
  'p2.unmapped': 'Service not mapped',
  'p2.cutCy': 'CY cut-off',
  'p2.book': 'Book sailing {v}',
  'p2.sPrice': 'Price low → high',
  'p2.sTt': 'Fastest transit',
  'p2.sValid': 'Longest validity',
  'p2.cond': 'Search criteria',
  'p2.from': 'From',
  'p2.to': 'to',
  'p2.pod': 'Port of discharge',
  'p2.pol': 'Port of loading',
  'p2.dc': 'DC · Dry cargo',
  'p2.rf': 'RF · Reefer cargo',
  'p2.search': 'Search rates',
  'p2.lead': 'Look up freight rates by lane',
  'p2.polL': 'Port of loading (POL)',
  'p2.podL': 'Port of discharge (POD)',
  'p2.swap': 'Swap POL and POD',
  'p2.etdIn': 'ETD within',
  'p2.etdRange': 'ETD range',
  'p2.w2': '2 weeks',
  'p2.w4': '4 weeks',
  'p2.w6': '6 weeks',
  'p2.searchSched': 'Search schedule',
  'p2.emptyT': 'No rates or sailings for this lane',
  'p2.nopermT': 'Sailing schedule only',
  'p2.emptyD': 'Ask Pricing for a rate — usually answered within a working day.',
  'p2.nopermD': 'This account cannot look up freight rates. Request Sales / Pricing access in Settings.',
  'p2.errD': 'The carrier schedule source is not responding. Saved rates can still be searched when you retry.',
  'p2.retry': 'Retry',
  'p2.byCarrier': 'Filter by carrier',
  'p2.allCarriers': 'All carriers',
  'p2.tier': 'Rate tier',
  'p2.t1': 'Tier 1',
  'p2.t2': 'Tier 2',
  'p2.cost': 'Buy rate',
  'p2.free2': 'Custom margin',
  'p2.editMarg': 'Edit custom margin',
  'p2.marg': 'Margin',
  'p2.filterRes': 'Filter rate results',
  'p2.filter': 'Filter',
  'p2.sort': 'Sort',
  'p2.reset': 'Reset',
  'p2.validRows': '{n} valid rate rows',
  'p2.done': 'Done',
  'p2.results': 'Rate results',
  'p2.expiredNote': 'Expired rates (not listed)',
  'p2.noSailT': 'No sailings in this ETD range',
  'p2.noSailD': 'Try a wider ETD range or another lane.',
  'p2.sched': 'Sailing schedule',
  'p2.what': 'Look up',
  'p2.title': 'Rates & Schedules',
  'p2.weeks': '{n} weeks',
  'p2.bookN': 'Book {n} sailings at once',
  'p2.tickBook': 'Tick sailings for Multi Book',
  'p2.recentTool': 'Recent: lanes searched, pending rate inquiries, quotes',
  'p2.more': 'More actions',
  'p2.tickQuote': 'Tick rate rows to create a quote',
  'p2.quote': 'Create quote',
  'p2.recentAria': 'Recently searched lanes',
  'p2.recent': 'Search a recent lane again',
  'p2.margD': 'Added on top of each carrier’s buy rate; may be negative for special offers (rate approval needed).',
  'p2.cancel': 'Cancel',
  'p2.apply': 'Apply',
});
